<h3 kb-heading>{{heading}}</h3>
<ul>
  @for (link of iconLinks; track link) {
    <li>
      <a kb-icon [icon]="link.icon" icon-uppercase icon-center [attr.aria-label]="link.ariaLabel" [kbRouterOrExternalLink]="link.href" [attr.target]="link.target"></a>
    </li>
  }
</ul>
